import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Filter = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="filter icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M19.7795 2H4.22049C2.53323 2 1.60414 3.96061 2.67257 5.26647L8.54791 12.4475C8.84027 12.8048 9 13.2522 9 13.7139V20C9 21.1046 9.89543 22 11 22H13C14.1046 22 15 21.1046 15 20V13.7139C15 13.2522 15.1597 12.8048 15.4521 12.4475L21.3274 5.26648C22.3959 3.96061 21.4668 2 19.7795 2Z"
    />
  </svg>
)
